@if (backRouterLink && backRouterLinkLabel) {
  <div class="top-header">
    <a mat-button
       [routerLink]="backRouterLink"
       queryParamsHandling="preserve"
       class="top-header__go-back text-primary-hover"
    >
      <mat-icon>
        navigate_before
      </mat-icon>

      {{ backRouterLinkLabel | translate }}
    </a>
  </div>
}
